import { Directive } from '@angular/core'
import { NzTableSortOrder } from 'ng-zorro-antd/table'

import {
  ChangeEventParams,
  TableDataBase,
} from '../components/table/table.component'
import { Sorting } from '../repositories/base.repository'

export type TableData = TableDataBase
export type ActiveSorting = Array<{ key: string; value: NzTableSortOrder }>

@Directive()
export abstract class TableBaseAbstract {
  public isLoading = true

  public abstract tableData: TableData[]
  public total: number = 0
  public pageIndex: number = 1
  public pageSize: number = 10
  public activeSorting!: ActiveSorting
  public sword!: string

  protected constructor() {}

  protected abstract updateTableData(): void

  public changeTableHandler(params: ChangeEventParams): void {
    this.pageIndex = params.pageIndex
    this.pageSize = params.pageSize
    this.activeSorting = params.sort.filter((s) => s.value)

    this.updateTableData()
  }

  protected getSorting(): Sorting[] | undefined {
    let sorting: Sorting[] | undefined = undefined

    if (this.activeSorting.length > 0) {
      sorting = this.activeSorting.map((sort) => ({
        property: sort.key,
        direction: sort.value === 'descend' ? 'des' : 'asc',
      }))
    }
    return sorting
  }
}
